/** User-facing copy the hub's cards share, in both panes. */
export const TEXTS = {
  /** The toggle on a clamped line, the same wherever a card clamps one. */
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',

  REJECTION_REASON: 'Rejection reason',
  /** Over the note Clive withdrew an action with, which no one rejected. */
  REASON: 'Reason',
  /** Over CMS's sentence on why a waiting action was not run unattended. */
  WAITING_REASON: 'Why it needs approval',
  /** The handler's own words, where they answered a question in them rather than with an option. */
  YOUR_ANSWER: 'Your answer',
  /** The line an activity card ends on, for a question answered in the handler's own words. */
  YOUR_ANSWER_LINE: (answer: string): string => `Your answer: ${answer}`,

  /** What a screen reader hears for the return mark, before the label of a stage the claim was sent back to. */
  BACK_TO: 'Back to',
};
